import { z } from 'zod';
import { DbJsonSchema } from '../../../dbJsonSchemas.js';
import { RoleCode } from '../../../enums/enum.js';
import { ShopifyPlan } from '../../../shopifyPlans.js';
import { enumToZodLiteralUnion } from '../../../zodExtensions.js';
const store = z.object({
    id: z.number(),
    name: z.string(),
    shopifyPlan: z.enum(ShopifyPlan).nullable(),
    estimatedAnnualReturns: z.number().optional(),
    invoiceDefinition: z
        .object({
        endDate: z.string(),
        id: z.number(),
    })
        .optional(),
    ianaTimezone: z.string().optional(),
    customerAppUrl: z.string(),
    currencyCode: z.string(),
    currencySymbol: z.string(),
    isTest: z.boolean().optional(),
    isCrewInstalled: z.boolean(),
    featureFlags: DbJsonSchema.Store.featureFlags,
    url: z.string().optional(),
});
const storeUserRole = z.object({
    storeId: z.number(),
    roleCode: enumToZodLiteralUnion(RoleCode),
    store,
});
const userEmailProperties = z.object({
    email: z.string().trim().email('Invalid email'),
    firstName: z.string().min(1, 'First name is required'),
    lastName: z.string().min(1, 'Last name is required'),
});
const storeOrgRole = z.object({
    roleCode: enumToZodLiteralUnion(RoleCode),
    organizationId: z.number(),
    storeIds: z.array(z.number()),
    organizationName: z.string(),
    isCorsoOrg: z.boolean(),
});
// user loaded into the UI containing all the store user roles for the user
export const userWithStoreUserRoles = z
    .object({
    id: z.number(),
    idFromPlatform: z.string(),
    storeUserRoles: z.array(storeUserRole),
    organizationUserRoles: z.array(storeOrgRole),
})
    .merge(userEmailProperties);
//! not to future use, the merchant admin operates with a single role for a user
export const storeUser = userWithStoreUserRoles
    .omit({
    storeUserRoles: true,
    organizationUserRoles: true,
    idFromPlatform: true,
})
    .merge(z.object({
    storeUserRole: storeUserRole.omit({ store: true }),
    organizations: z
        .array(z.object({
        organizationId: z.number(),
        organizationName: z.string(),
    }))
        .optional(),
}));
export const storeUserCreate = storeUser
    .omit({
    id: true,
    organizations: true,
})
    .required();
export const userSignUp = userEmailProperties;
export const userSignUpAndOnboard = userSignUp.merge(z.object({
    estimatedAnnualClaims: z.string(),
    phone: z.string().optional(),
    productsOfInterest: z
        .array(z.string())
        .min(1, 'Select at least one product'),
}));
export const storeUserSignUp = z.discriminatedUnion('isOnboardingComplete', [
    userSignUp.merge(z.object({ isOnboardingComplete: z.literal(true) })),
    userSignUpAndOnboard.merge(z.object({ isOnboardingComplete: z.literal(false) })),
]);
export const storeUserUpdate = storeUser
    .pick({
    id: true,
    firstName: true,
    lastName: true,
    email: true,
    storeUserRole: true,
})
    .required();
//# sourceMappingURL=user.js.map